/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiTransaction } from './InternalApiTransaction';
import {
    InternalApiTransactionFromJSON,
    InternalApiTransactionFromJSONTyped,
    InternalApiTransactionToJSON,
    InternalApiTransactionToJSONTyped,
} from './InternalApiTransaction';

/**
 * 
 * @export
 * @interface InternalApiTransactionsPage
 */
export interface InternalApiTransactionsPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionsPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiTransaction>}
     * @memberof InternalApiTransactionsPage
     */
    content: Array<InternalApiTransaction>;
}

/**
 * Check if a given object implements the InternalApiTransactionsPage interface.
 */
export function instanceOfInternalApiTransactionsPage(value: object): value is InternalApiTransactionsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiTransactionsPageFromJSON(json: any): InternalApiTransactionsPage {
    return InternalApiTransactionsPageFromJSONTyped(json, false);
}

export function InternalApiTransactionsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiTransactionFromJSON)),
    };
}

export function InternalApiTransactionsPageToJSON(json: any): InternalApiTransactionsPage {
    return InternalApiTransactionsPageToJSONTyped(json, false);
}

export function InternalApiTransactionsPageToJSONTyped(value?: InternalApiTransactionsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiTransactionToJSON)),
    };
}

